import React, { useState, useCallback } from "react";
import logo from './assets/images/kazcha_50logo.svg';
import text from './assets/images/kazcha_50text.svg';
import aayirathiri from './assets/images/kazcha_50aayirathiri.svg';
import hcbgImage from './assets/images/50th-kazcha-bg-01.jpg';
import counterBg from './assets/images/bg1.jpg';
import kazcha49 from './assets/images/Kazcha_49.jpg';
import kazcha48 from './assets/images/Kazcha_48.jpg';
import kazcha47 from './assets/images/Kazcha_47.jpg';
import kazcha46 from './assets/images/Kazcha_46.jpg';
import CountdownTimer from './components/CountdownTimer';
import {Footer} from './components/Footer';
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { photos } from "./components/photos";
import { videos } from "./components/videos";

import './components/Counter.css';

function App() {
  const expDate = new Date("2023-02-20T22:30:00.000+05:30");

  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };


  return (
    <div className='bg-black text-light'>
      <section className='container-fluid' style={{
        backgroundImage: 'url('+hcbgImage+')',
        backgroundSize: "contain",
        color: "#000000"
      }}>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 text-center'>
                <img src={aayirathiri} style={{maxWidth: '540px'}} className="pt-5" alt='aayirathiri mahotsavam' />
                <img src={logo} className="rounded mx-auto d-block" style={{maxWidth: '540px'}} alt="ഉദുമ പടിഞ്ഞാർക്കര തിരുമുൽക്കാഴ്ച" />
                <img src={text} className="pt-4 pb-5" style={{maxWidth: '540px'}} alt='feb 20, 2023' />
            </div>
          </div>          
        </div>
      </section>
      <section style={{
        backgroundImage: 'url('+counterBg+')',
        backgroundSize: "cover",
        color: "#000000"
      }}>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 text-center pt-4 pb-4'>
              <CountdownTimer targetDate={expDate} />
            </div>
          </div>          
        </div>


      </section>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3 col-sm-6 m-0 p-0">
            <img src={kazcha49} className="img-fluid" alt='Kazcha 2022' />
          </div>
          <div className="col-md-3 col-sm-6 m-0 p-0">
            <img src={kazcha48} className="img-fluid" alt='Kazcha 2021' />
          </div>
          <div className="col-md-3 col-sm-6 m-0 p-0">
            <img src={kazcha47} className="img-fluid" alt='Kazcha 2020' />
          </div>
          <div className="col-md-3 col-sm-6 m-0 p-0">
            <img src={kazcha46} className="img-fluid" alt='Kazcha 2019' />
          </div>
        </div>
      </div>
      <section>
        <div>
          <Gallery photos={photos} onClick={openLightbox} />
          <ModalGateway>
            {viewerIsOpen ? (
              <Modal onClose={closeLightbox}>
                <Carousel
                  currentIndex={currentImage}
                  views={photos.map(x => ({
                    ...x,
                    srcset: x.srcSet,
                    caption: x.title
                  }))}
                />
              </Modal>
            ) : null}
          </ModalGateway>
        </div>
      </section>
      <section>
        <div className="container-fluid">
          <div className="row">
            {videos.map(video => 
              <div key={video.ylink} className="col-sm-12 col-md-6 col-lg-3 m-0 p-0">
                <iframe style={{width: '100%', minHeight: '270px'}} src={video.ylink + "?rel=0&amp;controls=1&amp;showInfo=0&amp;modestbranding=1&amp;autohide=1"} frameBorder='0' allowFullscreen title={video.title}></iframe>
              </div>         
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default App;
